export default __webpack_public_path__ + "static/logo-65814e43301822592ba60d47a8770e6c.png";